// extracted by mini-css-extract-plugin
export default {"loading":"_1Ac2xPnQu-BvcefBXxJyt5","content":"kpEq3zyH3TbKzkhyST5ll","item":"_3DH8LCIscF1RpAN2zYA9vv","itemName":"_2ac7uQNdW9DmAHOwPagrnn","itemSwitch":"pHM8B7hd6LqNNPEVTJhJC"};